<template>
  <v-app-bar
      app
      color="white"
      flat
      class="header-layout"
  >
    <v-container class="col-10 py-0 fill-height d-flex justify-space-between">
      <div class="header-actions">
        <div class="d-flex align-center">
          <v-btn
            v-if="type === 'return' || type === 'return-search' || $route.path == '/transactions-renewal' || $route.path == '/tasks-renewal' || $route.path == '/members-renewal' || $route.path == '/service-packages'"
            @click="$router.go(-1)"
            class="return-back"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-autocomplete
              v-if="(type === 'search' || type === 'return-search' || type === 'search-crm')"
              colspan="1"
              :items="listClient ? listClient.client : []"
              item-value="client_id"
              item-text="name"
              placeholder="Поиск клиентов"
              hide-no-data
              :search-input.sync="search"
              v-model="select"
              :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '300'}"
              :no-filter=true
              class="rounded-lg"
              append-icon=""
              hide-details
              outlined
              dense
              background-color="white"
              style="height: 48px;padding-top: 5px; width: 300px;"
              @click="getClientSearch()"
          >
            <template v-slot:prepend-inner>
              <v-icon>mdi-magnify</v-icon>
            </template>
            <template v-slot:item=" { item } ">
              <a v-if="type === 'return-search'" @click="changeUsername(item.client_id)" class="aa d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                {{ item.name }} тел.:{{ item.phone }}
              </a>
              <router-link v-if="type === 'search' && $route.path !== '/desktop'" :to="{ name: 'Desktop', params: { client_id: item.client_id, save_search_data:item} }" class="d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                {{ item.name }} тел.:{{ item.phone }}
              </router-link>
              <a v-if="type === 'search' && $route.path === '/desktop'" @click="changeUsername4(item.client_id)" class="d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                {{ item.name }} тел.:{{ item.phone }}
              </a>
              <router-link v-if="type === 'search-crm' && $route.path !== '/desktop' && $route.path !== '/sales-monitor'" :to="{ name: 'CardClientNew', params: { client_id: item.client_id} }" class="d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                {{ item.name }} тел.:{{ item.phone }}
              </router-link>
              <a v-if="type === 'search-crm' && $route.path === '/sales-monitor'" @click="changeUsername2(item.client_id)" class="d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                {{ item.name }} тел.:{{ item.phone }}
              </a>
            </template>

  

          </v-autocomplete>

          <div v-if="searchClientList && closeSearch && (!search || search.length < 2)" style="
          position: absolute;
              top: 60px;
              background: white;
              z-index: 900;
              width: 300px;
              padding: 10px 20px;
              border: 1px solid #eee;
              transition: 0.5s;
          ">

            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px;">
            <h3>История поиска:</h3>
            <div @click="closeSearch = false" style="cursor: pointer;">X</div>
          </div>
            <hr>
            <div v-for="client in searchClientList.data" :key="client.client_id" style="margin:5px 0px;" class="">
              <a v-if="type === 'return-search'" @click="changeUsername3(client.client_id)" class="aa d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                {{ client.fio }} тел.:{{ client.phone }}
              </a>
              <router-link v-if="type === 'search' && $route.path !== '/desktop'" :to="{ name: 'Desktop', params: { client_id: client.client_id} }" class="d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                {{ client.fio }} тел.:{{ client.phone }}
              </router-link>
              <a v-if="type === 'search' && $route.path === '/desktop'" @click="changeUsername3(client.client_id, 22)" class="d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                {{ client.fio }} тел.:{{ client.phone }}
              </a>
              <router-link v-if="type === 'search-crm' && $route.path !== '/desktop' && $route.path !== '/sales-monitor'" :to="{ name: 'CardClientNew', params: { client_id: client.client_id} }" class="d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                {{ client.fio }} тел.:{{ client.phone }}
              </router-link>
              <a v-if="type === 'search-crm' && $route.path === '/sales-monitor'" @click="changeUsername3(client.client_id, true)" class="d-flex" style="padding:0px 10px;width:100%;align-items: center; text-decoration: none; color: black">
                {{ client.fio }} тел.:{{ client.phone }}
              </a>
            </div>

          </div>

          <div v-if="(search && search.length > 1) && (!listClient || !listClient.client || listClient.client.length == 0)"
            style="
          position: absolute;
              top: 60px;
              background: white;
              z-index: 900;
              width: 300px;
              padding: 10px 20px;
              border: 1px solid #eee;
              transition: 0.5s;
          "
          >
            Поиск не дал результатов

            <hr>
            <v-btn
              @click="setNewClient()"
              class="search-button"
              style="margin-top: 10px !important;"
          >
            Создать клиента
          </v-btn>
          
          </div>

          <v-btn
              v-if="(type === 'search' || type === 'return-search') && $route.path !== '/sales-monitor' && $route.path !== '/extension' && $route.path !== '/transactions-renewal' && $route.path !== '/tasks-renewal' && $route.path !== '/members-renewal' && $route.path !== '/service-packages'"
              @click="dialogClient = true, phone = null"
              class="search-button"
              style="margin-top: 0 !important;"
          >
            Создать клиента
          </v-btn>
          <v-btn
              v-if="(type === 'search' || type === 'search-crm') && ($route.path === '/sales-monitor' || $route.path === '/extension')"
              @click="createDeal"
              class="search-button"
              style="margin-top: 0 !important;"
          >
            + Создать сделку
          </v-btn>
        </div>
      </div>
      <div class="profile d-flex align-center">

        <div v-if="isLoading || isLoading2 || isLoadingMonitor" style="position:absolute; left:42%; 
            top: 40vh;
            display: flex;
            align-items: center;
            justify-content: center;
        ">
          <v-progress-circular
            color="green"
            indeterminate
            style="width:200px; height:200px; z-index:999;"
          ></v-progress-circular>
        </div>
        <div style="margin-right:10px;">
          <span style="cursor:pointer;" @click="getClientWide()">История поиска</span>
        </div>

        <div v-if="wideHistory" style="
                position: absolute;
                right: 0%;
                top: 78px;
                display: flex;
                flex-direction:column;
                height: 100vh;
                width: 500px;
                background: white;
                border: 1px solid #e0e0e0;
                transition: 0.5s;
                padding:20px 15px;
                font-size:20px;
                overflow-y: scroll;
                padding-bottom: 100px
            ">
          <div style="display:flex;  width:100%;">
            <h2 style="margin-bottom:50px; width:90%;">История посещений</h2>
            <v-btn icon @click="wideHistory = false">
                <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </div>

          <div  v-for="(client, index) in wideHistoryAr" :key="client[0].created">
              <div style="display:flex; flex-direction:column;">
                <div style="font-weight:bold; font-size:20px;">Дата: {{ index }}</div>
                  <div v-for="clientitem in client" :key="clientitem.clien_id" style="display:flex; flex-direction:column; padding-left:20px;">
                    <div>Время: {{ clientitem.time }}</div>
                    <div style="display:flex;">Клиент: 
                      <router-link v-if="$route.path === '/desktop'" :to="{ name: 'CardClient', params: { client_id: clientitem.client_id} }" class="d-flex" style="">
                      {{ clientitem.fio }}
                      </router-link>
                      <router-link v-else :to="{ name: 'Desktop', params: { client_id: clientitem.client_id} }" class="d-flex" style="">
                      {{ clientitem.fio }}
                      </router-link>
                    </div>
                    <div>Телефон: {{ clientitem.phone }}</div>
                    <br>
                  </div>
                  <hr>
                  <br>
              </div>
          </div>
       

        </div>
        <div class="profile-name">
            {{userFIO}}
            <span class="profile-position">
              {{userType}}
            </span>
        </div>
        <v-menu
            bottom
            left
            offset-y
            rounded="lg"
            content-class="custom__menu"
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              class="profile-avatar ml-3"
              v-bind="attrs"
              v-on="on"
            >
              <img src="/playground_assets/mediumuseri324-pp8g.svg" alt="">
            </div>
          </template>
          <v-list>
            <v-list-item
                @click="makeLogout()"
            >
              <v-list-item-title>Выйти из профиля</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-row justify="center">
        <v-dialog
            v-model="dialogClient"
            persistent
            max-width="700px"
        >
          <v-card rounded="lg">
            <v-card-title class="justify-space-between">
              <div></div>
              <div>
                <h4>Новый клиент</h4>
              </div>
              <v-btn icon @click="dialogClient = false, phone = null" >
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-form ref="form" @submit.prevent="submit">
                  <v-row>
                    <v-col
                        cols="12"
                        sm="6"
                        md="3"
                    >
                      <div class="user-avatar">
                        <img
                            v-if="!isCameraOpen"
                            src="/playground_assets/mediumcamera3282-238l.svg"
                            style="height: 37px; width: 46px"
                        />
                        <div v-show="isCameraOpen && isLoading2" class="camera-loading">
                          <ul class="loader-circle">
                            <li></li>
                            <li></li>
                            <li></li>
                          </ul>
                        </div>
                        <div v-if="isCameraOpen" v-show="!isLoading2" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                          <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                          <video v-show="!isPhotoTaken" style="border-radius:100%;" ref="camera" :width="210" :height="210" autoplay></video>
                          <canvas v-show="isPhotoTaken" style="border-radius:100%;" id="photoTaken" ref="canvas" :width="210" :height="210"></canvas>
                        </div>
                      </div>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="9"
                        style="display: flex; align-items: center; justify-content: start"
                    >
                      <div class="edit-button" >
                          <v-btn type="button" class="button__lighten-success" style="margin-top: 0 !important;" @click="toggleCamera">
                            <span v-if="!isCameraOpen">Изменить фото</span>
                            <span v-else>Закрыть камеру</span>
                          </v-btn>
                          <div v-if="isCameraOpen && !isLoading2 && !isPhotoTaken" class="camera-shoot" style="padding: 8px 20px !important;">
                            <button type="button" class="button" @click="takePhoto" style="width:40px; height:40px;">
                              <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png" style="width:30px; height:30px;">
                            </button>
                          </div>
                          <!-- <div v-if="isPhotoTaken && isCameraOpen" class="camera-download" style="width:100px;height:40px; padding-top:10px;">
                                    <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button" @click="downloadImage">
                                      Сохранить
                                    </a>
                           </div> -->
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="mt-5">
                    <v-col
                        cols="12"
                        sm="6"
                        md="4"
                    >
                      <label>Фамилия</label>
                      <v-text-field
                          v-model="middle_name"
                          label="Фамилия"
                          class="rounded-lg"
                          outlined
                          dense
                          style="height: 30px;margin-top: 10px"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="4"
                    >
                      <label>Имя <span style="color: #D53025">*</span></label>
                      <v-text-field
                          v-model="first_name"
                          :rules="firstNameRules"
                          label="Имя"
                          class="rounded-lg"
                          outlined
                          dense
                          style="height: 30px;margin-top: 10px"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="4"
                    >
                      <label>Отчество</label>
                      <v-text-field
                          v-model="last_name"
                          label="Отчество"
                          class="rounded-lg"
                          outlined
                          dense
                          style="height: 30px;margin-top: 10px"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-5">
                    <v-col
                        cols="12"
                        sm="6"
                        md="4"
                    >
                      <label>Телефон <span style="color: #D53025">*</span></label>
                      <v-text-field
                          v-model="phone"
                          :rules="phoneRules"
                          v-mask="'+7 (###) ###-##-###'"
                          label="Телефон"
                          class="rounded-lg"
                          outlined
                          dense
                          style="height: 30px;margin-top: 10px"
                      ></v-text-field>
                       <!-- v-mask="'+7 (###) ###-##-##'" -->
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="4"
                    >
                      <label>Электронная почта</label>
                      <v-text-field
                          v-model="email"
                          label="Электронная почта"
                          class="rounded-lg"
                          outlined
                          dense
                          style="height: 30px;margin-top: 10px"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        md="4"
                    >
                      <label>Пол</label>
                      <v-select
                          v-model="gender"
                          :items="genderTypes"
                          item-value="type_id"
                          item-text="type_name"
                          label="Пол"
                          class="rounded-lg"
                          outlined
                          dense
                          style="height: 30px;margin-top: 10px"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-card-actions style="padding: 30px 10px !important;">
                      <button
                          class="button button__success"
                          ref="activator"
                          type="submit"
                          :disabled="isLoading"
                      >
                        Сохранить
                      </button>
                      <v-text-field
                          v-model="bracelet"
                          label="Браслет/карта"
                          @focusin="searchBracelet"
                          @focusout="stopCard"
                          class="rounded-lg ml-5"
                          hide-details
                          outlined
                          dense
                      ></v-text-field>
                    </v-card-actions>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
      <v-row justify="center">
        <v-dialog
            v-model="dialogDeal"
            persistent
            max-width="700px"
        >
          <v-card rounded="lg">
            <v-card-title class="justify-space-between">
              <div></div>
              <div>
                <h4>Новая сделка</h4>
              </div>
              <v-btn icon @click="dialogDeal = false" >
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container>

              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>

        <!-- Enter Modal -->
        <v-row justify="center">
          <v-dialog
              v-model="taskModal"
              persistent
              max-width="600px"
          >
          <v-card rounded="lg" >
     
            <v-card-title class="justify-space-between">
                <div></div>
                <div>
                  <h4 style="font-weight:bold;">У вас есть задачи требующие внимания, открыть их?</h4>
                </div>
                <v-btn icon @click="taskModal = false" >
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>

                <v-card-text>
                  <v-container>
       
                      <v-row>
                        <v-col style="display:flex; align-items:center; justify-content:center;">
                          <v-btn
                              class="button button__success"
                              style="width: 30% !important; height: 48px !important;"
                              @click="goToTasks()"
                          >
                            Да
                          </v-btn>
                          <!-- <router-link hidden :to="{ name: 'ManagerTasks', params: {attent:true}}" target="_blank" class="button button__success task_link" style="display:flex;align-items: center; justify-content: center; text-decoration: none; height:48px; width:0px; background:transparent !important;">
                          </router-link> -->
                          <v-btn
                              class="button button__danger"
                              style="width: 30% !important; height: 48px !important; margin-top:0px !important; margin-left:20px;"
                              @click="taskModal = false"
                          >
                            Нет
                          </v-btn>
                        </v-col>
                      </v-row>
                  </v-container>
                </v-card-text>

          </v-card>
          </v-dialog>
         </v-row>

         <v-row justify="center">
      <v-dialog
          v-model="showClientPhoneModal"
          persistent
          max-width="800px"
      >
        <v-card rounded="lg">
          <v-card-title class="justify-space-between">
            <div></div>
            <div>
              <h4>Клиент(ы) с такими данными (номер телефона) уже существует!</h4>
            </div>
            <v-btn icon @click="showClientPhoneModal = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form_phone" >
                <v-row v-for="(line,index) of existClients" :key="line.client_id" style="display:flex; align-items:center; justify-content: space-between; font-size: 16px;">
                  <div>{{ index + 1 }}</div>
                  <div>
                    {{ line.name}}
                  </div>
                  <div>
                    {{ line.phone}}
                  </div>
                  <v-card-actions style="padding: 20px 10px !important;">
                    <button
                        class="button button__success ml-3"
                        ref="activator"
                        type="button"
                        style="margin-top: 0px !important; padding: 8px 20px !important; border-radius: 12px !important;"
                        @click="openExist(line.client_id)"
                    >
                      Открыть существуюшего
                    </button>
                  
                  

                  </v-card-actions>
                </v-row>
                <v-row style="display:flex; align-items: center; justify-content: center;">
                  <button
                        class="button button__danger ml-3"
                        ref="activator"
                        type="button"
                        style="margin-left:10px;"
                        @click="existClients = [], phone = null, showClientPhoneModal = false"
                    >
                      Отменить
                    </button>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>


    </v-container>
  </v-app-bar>
</template>

<script>
import {mapState} from "vuex";
import {clientActionTypes} from '@/store/modules/client';
import {receptionActionTypes} from '@/store/modules/reception';
import {monitorActionTypes} from '@/store/modules/monitor';
import {getItem, setItem} from "../helpers/persistanceStorage";
import {actionTypes} from '@/store/modules/user'

export default {
  name: "Header",
  props: ['type'],
  data() {
    return {
      basePhoto:null,
      search: '',
      select: '',
      bracelet: '',
      counterInterval: null,
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading2: false,
      dialogClient: false,
      dialogDeal: false,
      first_name: '',
      isLoadingMonitor:false,
      firstNameRules: [
        v => !!v || 'Имя обязательное поле'
      ],
      middle_name: '',
      middleNameRules: [
        v => !!v || 'Фамилия обязательное поле'
      ],
      last_name: '',
      lastNameRules: [
        v => !!v || 'Отчество обязательное поле'
      ],
      gender: '',
      genderRules: [
        v => !!v || 'Пол обязательное поле'
      ],
      genderTypes : [
        {type_id: 1, type_name: 'Мужской'},
        {type_id: 2, type_name: 'Женский'},
      ],
      email: '',
      emailRules: [
        v => !!v || 'Электронная почта обязательное поле',
        v => /.+@.+\..+/.test(v) || 'Электронная почта не правильно заполнена',
      ],
      phone: '',
      phoneRules: [
        v => !!v || 'Телефон обязательное поле'
      ],
      closeSearch:false,
      defPhone:null,
      wideHistory:false,
      wideHistoryAr: [],
      tasksList:[],
      taskModal:false,
      taskInterval:null,
      showClientPhoneModal:false,
      existClients:[]
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.client.isLoading,
      listClient: state => state.client.listClient,
      searchClientList: state => state.client.searchClientList,
      userType: state => state.userType, //Роль пользователя
      userFIO: state => state.userFIO, //Фио пользователя
    })
  },
  mounted() {
    // setTimeout(() => {
    //     this.checkTasks()
    // }, 3600);
  },
  created: function(){
    if(!this.taskInterval){
      this.taskInterval =  setInterval(this.checkTasks, 60000);
    }
  },
  methods: {
    makeLogout(){
      this.$store.dispatch(actionTypes.logout, {
          logout:true
      })
        .then((response) => {
          this.$router.push({ path: '/logout' });
      })
    },
    openExist(client_id){
      if(this.$route.path !== '/desktop' ){
        this.$router.push({name: 'Desktop', params: {client_id: client_id}})
      } else {
        this.showClientPhoneModal = false
        this.dialogClient = false
        this.$emit('changeClient4', client_id)
      }
    },
    checkTasks(){
      //console.log('check Tasks')
      //console.log(this.$route.path)

      //console.log(getItem('tasks_opened'))

      if(this.$route.path !== '/manager-tasks' 
      && this.$route.path !== '/tasks' 
      && this.$route.path !== '/sales-monitor' 
      && this.$route.path !== '/potential-customers'
      && this.$route.path !== '/transactions'
      && this.$route.path !== '/deals-stage'
      && this.$route.path !== '/extension'
      && this.$route.path !== '/service-packages'
      && this.$route.path !== '/members-renewal'
      && this.$route.path !== '/transactions-renewal'
      && this.$route.path !== '/tasks-renewal'
      && this.$route.path !== '/deals-stage-renewal'
      ) {

            let client_id = getItem('user_id_1c')

            //console.log(client_id)

        let specialist_id = client_id;

          this.tasksList = []

          let startdate = '2024-01-01 00:00:00'
          let enddate = '2028-01-01 00:00:00'
          let page = 1
          let limit = 20

          //this.$store.dispatch(receptionActionTypes.desktopClientSale, {client_id})
          this.$store.dispatch(monitorActionTypes.getOverdueTasks, {
                  specialist_id,
                  manager_type:true
          })
          .then((response) => {
            if(response && response.success){
              this.isLoading2 = false
                if(response.monitor){

                  if(response.monitor){
                    for(let i = 0; i < response.monitor.length; i++) {
                      if(response.monitor[i].done === false && response.monitor[i].remind === 1){
                        
                        let timeEnd = response.monitor[i].time_end

                        if(timeEnd){
                          if(timeEnd.split('T')[0]){
                            let mmonth = timeEnd.split('T')[0].split('-')[1]
                            let dday = timeEnd.split('T')[0].split('-')[2]
                            //console.log(mmonth)
                            //console.log(dday)

                            let mmonth2 = new Date().getMonth() + 1;
                            let dday2 = new Date().getDate();

                            //console.log(mmonth2)
                            //console.log(dday2)

                            if(+mmonth < mmonth2){
                              this.tasksList.push(response.monitor[i])
                            } else if(+dday < dday2){
                              //console.log('mesjac tot zhe')
                              this.tasksList.push(response.monitor[i])
                            } else if(+dday === dday2){
                              //console.log('denj tot zhe')

                              let hhour2 = new Date().getHours(0)
                              let hhour = +timeEnd.split('T')[1].split(':')[0]

                              //console.log(hhour2)
                              //console.log(hhour)

                              if(hhour <= hhour2){
                                this.tasksList.push(response.monitor[i])
                              }

                            }

                          }
                        } 

                        

                      }
                    }
                  }

                  //console.log(this.tasksList)

                }
              
                if(this.tasksList.length > 0) {

                  this.$store.dispatch(monitorActionTypes.setOpened, {check:true}).then((res) => {
                      if(res && res.data){
                        //estj zuhe vkladka
                      } else if(res) {
                        this.taskModal = true
                      }
                  })


                      // if(!getItem('tasks_opened') || getItem('tasks_opened') === null || getItem('tasks_opened') === 'null'){
                      //   //this.taskModal = true
                      // } else {
                        
                      // }
                      
                }
                  
                  
            } else {
              alert('Проблема при загрузке данных клиента!')
          
            }
          }) 
          
        }
    },
    goToTasks(){
      this.taskModal = false
      //this.$router.push({ name: 'ManagerTasks', params: { attent: true }, target:"_blank" })

      let linkHref = document.getElementsByClassName("task_link");

      //console.log(linkHref)

      setItem('tasks_opened',true)
      
      //link.click();
      let link = document.createElement('a');
                      link.href = '/manager-tasks';
                      link.target = 'a_blank';
                      document.body.appendChild(link);
                      link.click();
                      link.remove();
      
    },
    getClientWide(){
        this.$store.dispatch(clientActionTypes.getSearchClient, {
          all: true
        })
          .then((resp) => {
            if(resp && resp.data){
              this.wideHistoryAr = resp.data
              this.wideHistory = true
              this.closeSearch = false

            }
            ////console.log(resp)
        })
    },  
    setNewClient(){
      if(this.search && this.search.length > 1){
        
        if(parseInt(this.search.replace( /\D/g, '')) > 3){
          //console.log(parseInt(this.search.replace( /\D/g, '')))
          this.defPhone = this.search
          this.phone = this.defPhone
          //console.log(this.phone)
        }
      }

      this.dialogClient = true
      
    },
    getClientSearch(){
        this.$store.dispatch(clientActionTypes.getSearchClient, {
          data: []
        })
          .then((resp) => {
            this.closeSearch = true


            //console.log(resp)
        })
    },  
    stopCard(){
      //console.log('stopp')
      clearInterval(this.counterInterval)
      this.$emit('stopInterval', 1)
    },
    fetchFeedCard(card_id) {
      this.bracelet = card_id;
    },
    changeUsername4(client_id) {
      console.log('changeClient4444444')
      this.search = '';
      this.select = '';
      this.$emit('changeClient4', client_id)
      this.closeSearch = false
    },
    changeUsername(client_id) {
      console.log('changeClient')
      this.search = '';
      this.select = '';
      this.$emit('changeClient', client_id)
      this.closeSearch = false
    },
    changeUsername2(client_id) {
      console.log('changeClient2')
      this.search = '';
      this.select = '';
      this.$emit('changeClient2', client_id)
      this.closeSearch = false
      this.$router.push({ name: 'CardClientNew', params: { client_id: client_id } })
    },
    changeUsername3(client_id,type) {
      console.log('changeClient3')
      this.search = '';
      this.select = '';
      //this.$emit('changeClient2', client_id)
      this.closeSearch = false
      if(type && type === 22){
        this.$emit('changeClient', client_id)
      } else if(type) {
        this.$router.push({ name: 'CardClientNew', params: { client_id: client_id } })
      } else {
        this.$router.push({ name: 'Desktop', params: { client_id: client_id } })
      }
      
    },
    toggleCamera() {
      if(this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },
    createCameraElement() {
      this.isLoading2 = true;

      const constraints = (window.constraints = {
        audio: false,
        video: true
      });

      navigator.mediaDevices
          .getUserMedia(constraints)
          .then(stream => {
            this.isLoading2 = false;
            this.$refs.camera.srcObject = stream;
          })
          .catch(error => {
            this.isLoading2 = false;
            alert("May the browser didn't support or there is some errors.");
          });
    },
    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach(track => {
        track.stop();
      });
    },
    takePhoto() {
      if(!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.camera, 0, 0, 210, 210);

      const getBase64StringFromDataURL = (dataURL) =>
        dataURL.replace('data:', '').replace(/^.+,/, '');

      this.basePhoto = getBase64StringFromDataURL(document.getElementById("photoTaken").toDataURL("image/jpeg"));

      //console.log(this.basePhoto)

    },
    downloadImage() {
      const download = document.getElementById("downloadPhoto");
      const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
          .replace("image/jpeg", "image/octet-stream");

      download.setAttribute("href", canvas);
    },
    submit() {
      this.stopCard();
      if (this.$refs.form.validate()) {

        this.existClients = []
      
        if(!this.phone || this.phone === null){
          alert('Не верный формат номера телефона!')
          return
        }

      let digitsOnlyPhone = this.phone.replace(/\D/g, '')
        // if(digitsOnlyPhone.length < 11 || digitsOnlyPhone.length > 12){
        //   this.phone = null
        //   alert('Не верный формат номера телефона!')
        //   return
        // }

        this.$store.dispatch(clientActionTypes.searchClient, {
        client_field: this.phone
          }).then((response) => {
            if(response && response.client && response.client.length > 0){
              
                let phoneAr = []
              for(let i = 0; i < response.client.length; i++){
                const digitsOnly = response.client[i].phone.replace(/\D/g, '')
                let clientObj = {
                  phone_cleared:digitsOnly,
                  phone:response.client[i].phone,
                  name:response.client[i].name,
                  client_id:response.client[i].client_id
                }
                phoneAr.push(clientObj)
              }

              console.log(phoneAr)

              this.existClients = phoneAr.filter((item) => item.phone_cleared === digitsOnlyPhone);

              console.log(this.existClients)

              if(this.existClients.length > 0){
                this.showClientPhoneModal = true
              } else {
                this.$store.dispatch(clientActionTypes.createClient, {
                  from: 'reception',
                  last_name: this.last_name,
                  first_name: this.first_name,
                  middle_name: this.middle_name,
                  phone: this.phone,
                  email: this.email,
                  gender: this.gender,
                  client_card: this.bracelet,
                  photo: this.basePhoto
                })
                    .then((response) => {
                      //this.downloadImage();
                      if (response && response.success) {
                        if (this.$route.path === '/desktop') {
                          this.$store.dispatch(receptionActionTypes.desktopClient, {client_id: response.client.client_id});
                          this.dialogClient = false;
                        } else {
                          this.$router.push({ name: 'Desktop', params: { client_id: response.client.client_id } })
                        }
                      } else {
                        alert('Ошибка создания клиента!')
                      }
                    })

              }
            } else {

              this.$store.dispatch(clientActionTypes.createClient, {
                  from: 'reception',
                  last_name: this.last_name,
                  first_name: this.first_name,
                  middle_name: this.middle_name,
                  phone: this.phone,
                  email: this.email,
                  gender: this.gender,
                  client_card: this.bracelet,
                  photo: this.basePhoto
                })
                    .then((response) => {
                      //this.downloadImage();
                      if (response && response.success) {
                        if (this.$route.path === '/desktop') {
                          this.$store.dispatch(receptionActionTypes.desktopClient, {client_id: response.client.client_id});
                          this.dialogClient = false;
                        } else {
                          this.$router.push({ name: 'Desktop', params: { client_id: response.client.client_id } })
                        }
                      } else {
                        alert('Ошибка создания клиента!')
                      }
                    })

            }
          });


      }
    },
    sendRequest() {
      this.cardRightNow = false;
      var xmlhttp = new XMLHttpRequest();
      let vm = this

      xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
          //console.log('RESSS'+xmlhttp.responseText)
          //let responseTest = '3FB5DF5B ';
          if (xmlhttp.status == 200) {
            clearInterval(vm.counterInterval)
            if(xmlhttp.responseText.length>0)
            {
              if(!vm.cardRightNow)
              {
                var transformArray = xmlhttp.responseText.split(/(..)/g).filter(s => s);
                transformArray.reverse();
                var resultString = transformArray.join('')+'000000';
                //console.log(resultString);
                //console.log('Card has been placed on reader: '+resultString); // action here!!!!

                //vm.$router.push({ name: 'Desktop', params: { client_id: resultString } })
                vm.fetchFeedCard(resultString);
                vm.cardRightNow = true;
              }
            }
            else
            {
              vm.counterInterval = setInterval(vm.sendRequest, 1000);
              if(vm.cardRightNow)
              {
                cardRightNow = false;
                //console.log('no card');
                //console.log('Card has been removed from reader: '); //card removed (may be needed in future)
              }
            }
          }
          else if (xmlhttp.status == 400) {
            //console.log('There was an error 400');
          }
          else {
            //console.log('something else other than 200 was returned');
          }

        }
      };

      xmlhttp.open("GET", "http://localhost:8081/scard", true);
      xmlhttp.send();
    },
    searchBracelet() {
      this.counterInterval = setInterval(this.sendRequest, 1000);
    },
    createDeal() {
      let type = null
      if (this.$route.path === '/sales-monitor') {
        type = 'Продажа';
      }
      if (this.$route.path === '/extension') {
        type = 'Продление';
      }
      this.$store.dispatch(monitorActionTypes.getListDeal, {
        type
      })
          .then((response) => {
            if (response.monitor.length === 1) {
              this.$router.push({ name: 'CreateClient', params: { deal: response.monitor[0] } })
            }
          });
    }
  },
  destroyed: function(){
    clearInterval(this.counterInterval)
    clearInterval(this.taskInterval)
  },
  watch: {
    search() {
      if (this.search !== '' || !this.isLoading) {
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: this.search
        })
      } else {
        //console.log('prosto nazhali')
      }
    },
    dialogClient() {
      if (this.$route.path === '/main') {
        this.dialogClient ? this.$emit('stopInterval', 1) : this.$emit('startInterval', 1)
      }
    }
  }
}
</script>

<style scoped>
.profile-name {
  display: flex;
  flex-direction: column;
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
.profile-position {
  font-size: 13px;
  line-height: 16px;
  color: #767676;
}
.profile-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  background: #F1F1F1;
  border-radius: 23.75px;
}
.custom__menu {
  max-height: 112px !important;
  max-width: 218px !important;
}
.custom__menu > .v-list > .v-list-item {
  min-height: 32px !important;
}
.custom__menu > .v-list > .v-list-item > .v-list-item__title {
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 16px !important;
}

.search_client {
  min-width: 50%;
  display: flex;
  align-items: center;
}

.return-back {
  background-color: #fff !important;
  border: 1px solid #E0E0E0;
  border-radius: 12px;
  width: 48px;
  padding: 20px 16px !important;
  margin-right: 15px;
  box-shadow: none !important;
}

.edit-button {
  width: 100%;
  display: flex;
  align-items: center;
}

.user-avatar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
  width: 100px;
  height: 100px;
  border-radius: 145px;
  background-color: #F1F1F1;
}


.web-camera-container {
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 500px;
}
.web-camera-container .camera-button {
  margin-bottom: 2rem;
}
.web-camera-container .camera-box .camera-shutter {
  opacity: 0;
  width: 450px;
  height: 337.5px;
  background-color: #fff;
  position: absolute;
}
.web-camera-container .camera-box .camera-shutter.flash {
  opacity: 1;
}
.web-camera-container .camera-shoot {
  margin: 1rem 0;
}
.web-camera-container .camera-shoot button {
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
}
.web-camera-container .camera-shoot button img {
  height: 15px;
  object-fit: cover;
}
.web-camera-container .camera-loading {
  overflow: hidden;
  height: 100%;
  position: absolute;
  width: 100%;
  min-height: 150px;
  margin: 3rem 0 0 -1.2rem;
}
.web-camera-container .camera-loading ul {
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 999999;
  margin: 0;
}
.web-camera-container .camera-loading .loader-circle {
  display: block;
  height: 14px;
  margin: 0 auto;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  transform: translateX(-50%);
  position: absolute;
  width: 100%;
  padding: 0;
}
.web-camera-container .camera-loading .loader-circle li {
  display: block;
  float: left;
  width: 10px;
  height: 10px;
  line-height: 10px;
  padding: 0;
  position: relative;
  margin: 0 0 0 4px;
  background: #999;
  animation: preload 1s infinite;
  top: -50%;
  border-radius: 100%;
}
.web-camera-container .camera-loading .loader-circle li:nth-child(2) {
  animation-delay: 0.2s;
}
.web-camera-container .camera-loading .loader-circle li:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes preload {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}

</style>